// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/lost-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/lost-procedures/lost-procedures.js';

mount([g0]);
